import { render, staticRenderFns } from "./PodtEditSemiprodChild.vue?vue&type=template&id=2df2e6da&"
import script from "./PodtEditSemiprodChild.vue?vue&type=script&lang=js&"
export * from "./PodtEditSemiprodChild.vue?vue&type=script&lang=js&"
import style0 from "./PodtEditSemiprodChild.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports